/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  FaBox,
  FaCamera,
  FaRegHeart,
  FaRegUser,
  FaUnlockAlt,
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
// import { IoCompassOutline } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../utils/axiosInstance";
import toast from "react-hot-toast";
// eslint-disable-next-line no-unused-vars
import Loader from "../Loader";
import { imgUrl } from "../utils/imgUrl";

const LeftNav = React.memo(({ setProfileData, perofileData }) => {
  const [profileImg, setProfileImg] = useState(null);
  // const [profileApi, setProfileApi] = useState(null);
  const getAllInfo = async () => {
    try {
      await axiosInstance.get("user/profile").then((response) => {
        if (response?.data?.status === true) {
          setProfileData(response?.data?.user);
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    getAllInfo();
  }, []);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    updateProfile(file);
    if (file) {
      const blob = new Blob([file], { type: file.type });

      const url = URL.createObjectURL(blob);
      setProfileImg(url);
    }
  };

  const updateProfile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await axiosInstance.post("user/profile/image", formData);

      if (response?.data?.status === true) {
        toast.success(response?.data?.message || "Profile saved successfully!");
        getAllInfo();
      } else {
        toast.error(
          response?.data?.message || "Something went wrong, try again."
        );
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage =
        error?.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const navigate = useNavigate();
  const config = [
    {
      name: "Personal Info",
      path: "/userprofile",
      icon: <FaRegUser />,
    },
    {
      name: "Address",
      path: "/saveaddress",
      icon: <FaLocationDot />,
    },
    {
      name: "Order",
      path: "/myorder",
      icon: <FaBox />,
    },
    {
      name: "Favourite",
      path: "/wishlist",
      icon: <FaRegHeart />,
    },

    {
      name: "Change Password",
      path: "/changepassword",
      icon: <FaUnlockAlt />,
    },
  ];
  return (
    <div className="col-xl-3 col-lg-4 wow fadeInUp" data-wow-duration="1s">
      <div className="dashboard_menu">
        <div className="dasboard_header">
          <div className="dasboard_header_img">
            <img
              src={
                profileImg !== null && profileImg !== undefined
                  ? profileImg
                  : perofileData?.image !== null &&
                    perofileData?.image !== undefined
                  ? imgUrl + perofileData?.image
                  : `/images/loaderGif.gif`
              }
              alt="user"
              className="img-fluid w-100"
            />
            <label htmlFor="upload">
              <FaCamera />
            </label>
            <input type="file" onChange={handleFileChange} id="upload" hidden />
          </div>
          <h2>
            {perofileData?.first_name && perofileData?.last_name
              ? perofileData?.first_name + " " + perofileData?.last_name
              : "Please Fill Your Name Feild"}
          </h2>
        </div>

        <ul>
          {config.map((e, i) => (
            <li>
              <button onClick={() => navigate(e?.path)}>
                <span>{e?.icon}</span>
                {e?.name}
              </button>
            </li>
          ))}
          <li>
            <button onClick={logout}>
              <span>
                <LuLogOut />
              </span>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
});

export default LeftNav;
